import React, { Component } from 'react';
import Select from 'react-select';
import { dataUser, dataLocation } from '../Helpers/util';
import axiosInstance from '../../utils/axiosInstance';
import axios from 'axios';
const apiURL = require('./../../constant');
const URL_API = apiURL.PROD_URL;
const userDataLocal = dataUser();
const userDataLocal1 = dataLocation();
var UserObj = JSON.parse(userDataLocal);
var LocationObj = JSON.parse(userDataLocal1);
var vnArr = [];
var emailArr = [];
var phNoArr = [];
var nameArr = [];
var loadFilterData = true;

class ParkingReqFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: [],
      company_id: UserObj.company_id,
      status: '',
      statusObj: null,
      vehicleType: '',
      vehicleTypeObj: null,
      vehicleNo: '',
      vehicleNoObj: null,
      email: '',
      emailObj: null,
      phone: '',
      phNoObj: null,
      name: '',
      nameObj: null,
    };
  }

  componentDidMount() {
    if (loadFilterData) {
      nameArr = [];
      phNoArr = [];
      emailArr = [];
      vnArr = [];
      this.loadFilterData();
    }
  }

  loadFilterData = async () => {
    let authToken = JSON.parse(localStorage.getItem('headData'));
  
    let article = {
      company_id: UserObj ? UserObj.company_id : null,
      location_id: LocationObj,
    };
  
    try {
      // Await the axios request for parking filter data
      const response = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v1/parking/parking_filter`, article, {
        headers: {
          Authorization: authToken?.spintlyToken,
        },
      });
  
      // Extract the data from the response
      let data = response.data.data;
  
      // Process the data and push to the respective arrays
      data.forEach(element => {
        nameArr.push({
          value: element['user_name'],
          label: element['user_name'],
        });
        phNoArr.push({ value: element['phone'], label: element['phone'] });
        emailArr.push({ value: element['email'], label: element['email'] });
        vnArr.push({
          value: element['vehicle_number'],
          label: element['vehicle_number'],
        });
      });
  
      // Optionally: Set a flag or do something else here if needed after data is loaded
      loadFilterData = false;
  
    } catch (error) {
      // Handle any error that may occur during the request
      console.error('Error loading filter data:', error);
    }
  };
  

  reload = e => {
    this.setState({
      status: '',
      statusObj: null,
      vehicleNo: '',
      vehicleNoObj: null,
      email: '',
      emailObj: null,
      phone: '',
      phNoObj: null,
      name: '',
      nameObj: null,
      vehicleType: '',
      vehicleTypeObj: null,
    });
    this.props.sendFilterToParent(null);
  };

  submitFilter = e => {
    e.preventDefault();
    const params = {};

    if (this.state.name) params.name = this.state.name;
    if (this.state.phone) params.phone = this.state.phone;
    if (this.state.email) params.email = this.state.email;
    if (this.state.vehicleNo) params.vehicle_number = this.state.vehicleNo;
    if (this.state.vehicleType) params.wheeler = this.state.vehicleType;
    if (this.state.status) params.status = this.state.status;

    this.props.sendFilterToParent(params);
  };

  setName = data => {
    this.setState({
      name: data.value,
      nameObj: data,
    });
  };

  setPhoneNo = data => {
    this.setState({
      phone: data.value,
      phNoObj: data,
    });
  };

  setEmail = data => {
    this.setState({
      email: data.value,
      emailObj: data,
    });
  };

  setVehicleNo = data => {
    this.setState({
      vehicleNo: data.value,
      vehicleNoObj: data,
    });
  };

  setVehicleType = data => {
    this.setState({
      vehicleType: data.value,
      vehicleTypeObj: data,
    });
  };

  setStatus = data => {
    this.setState({
      status: data.value,
      statusObj: data,
    });
  };

  render() {
    const vehicleType = [
      {
        value: 2,
        label: '2 Wheeler',
      },
      {
        value: 4,
        label: '4 Wheeler',
      },
    ];

    const status = [
      {
        value: '1',
        label: 'Pending',
      },
      {
        value: '2',
        label: 'Approved',
      },
      {
        value: '3',
        label: 'Assigned',
      },
      {
        value: '4',
        label: 'Deleted',
      },
      {
        value: '5',
        label: 'Delete Request',
      },
      {
        value: '6',
        label: 'Rejected',
      },
      {
        value: '7',
        label: 'Rejected by SW',
      },
    ];

    return (
      <>
        <div className="custome modal fade right" id="myModal2" data-backdrop="static">
          <div className="modal-dialog custome">
            <div className="modal-content custome">
              <div className="formTitle">
                Parking Filters
                <button
                  type="button"
                  className="relateDox close"
                  data-dismiss="modal"
                >
                  x
                </button>
              </div>
              <div className="modal-body custome">
                <div className="addmemberformBody">
                  <form>
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="formAddmemGrid">
                          <label>Name</label>
                          <Select
                            value={this.state.nameObj}
                            onChange={this.setName}
                            options={nameArr}
                            className="nSelect"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="formAddmemGrid">
                      <label>Phone No.</label>
                      <Select
                        value={this.state.phNoObj}
                        onChange={this.setPhoneNo}
                        options={phNoArr}
                        className="nSelect"
                      />
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="formAddmemGrid">
                          <label>Email</label>
                          <Select
                            value={this.state.emailObj}
                            onChange={this.setEmail}
                            options={emailArr}
                            className="nSelect"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="formAddmemGrid">
                          <label>Vehicle Number </label>
                          <Select
                            value={this.state.vehicleNoObj}
                            onChange={this.setVehicleNo}
                            options={vnArr}
                            className="nSelect"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="formAddmemGrid">
                          <label>Vehicle Type </label>
                          <Select
                            name="vehicleType"
                            value={this.state.vehicleTypeObj}
                            onChange={this.setVehicleType}
                            options={vehicleType}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="formAddmemGrid">
                          <label>Status</label>
                          <Select
                            name="status"
                            value={this.state.statusObj}
                            onChange={this.setStatus}
                            options={status}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="addmemberFooter">
                      <div className="pull-right">
                        <button
                          className="btn btn-outline-dark solCancel"
                          type="button"
                          data-dismiss="modal"
                          onClick={this.reload}
                        >
                          Reset
                        </button>
                        <button
                          className="btn btn-success addDetails ml10"
                          data-dismiss="modal"
                          onClick={this.submitFilter}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          type="button"
          data-toggle="modal"
          data-target="#myModal2"
          className="filter"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            onClick={this.props.clearSearch}
            viewBox="0 0 21.345 19.36"
          >
            <path
              id="Icon_feather-filter"
              data-name="Icon feather-filter"
              d="M22.845,4.5H3l7.938,9.387v6.489l3.969,1.984V13.887Z"
              transform="translate(-2.25 -3.75)"
              fill="none"
              stroke="#333"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
          </svg>
        </div>
      </>
    );
  }
}

export default ParkingReqFilter;
